<section class="additional-coverage" data-testid="additional-coverage-section">
  <div class="additional-coverage__header">
    <button
      type="button"
      class="additional-coverage__accordion-trigger"
      [attr.aria-expanded]="expanded()"
      aria-controls="additional-coverage-panel"
      id="additional-coverage-heading"
      (click)="toggleExpanded()"
    >
      <puro-typography
        class="additional-coverage__accordion-title"
        variant="h5"
        component="span"
        color="primary"
      >
        {{ 'createShipment.serviceStep.additionalCoverage.accordionTitle' | translate }}
      </puro-typography>
      <puro-icon
        class="additional-coverage__chevron"
        [class.additional-coverage__chevron--collapsed]="!expanded()"
        name="open-chevron-up-arrow"
        size="sm"
        aria-hidden="true"
      />
    </button>

    @if (expanded()) {
      <p class="additional-coverage__required" data-testid="additional-coverage-required-legend">
        <span class="additional-coverage__required-mark" aria-hidden="true">**</span
        >{{ 'createShipment.serviceStep.additionalCoverage.requiredLegend' | translate }}
      </p>
    }
  </div>

  @if (expanded()) {
    <section
      id="additional-coverage-panel"
      class="additional-coverage__panel"
      aria-labelledby="additional-coverage-heading"
    >
      @if (errorSummaryMessages().length) {
        <app-form-error-summary
          class="additional-coverage__error-banner"
          data-testid="additional-coverage-error-banner"
          [title]="'createShipment.validation.errorSummaryTitle' | translate"
          [messages]="errorSummaryMessages()"
        />
      }

      <div class="additional-coverage__subtitle-row">
        <puro-typography variant="h5" component="h3" class="additional-coverage__subtitle">
          {{ 'createShipment.serviceStep.additionalCoverage.coverageTitle' | translate }}
        </puro-typography>
        <span class="visually-hidden" id="additional-coverage-tooltip-desc">{{
          'createShipment.serviceStep.additionalCoverage.coverageTooltip' | translate
        }}</span>
        <puro-tooltip
          #coverageTooltip
          [content]="'createShipment.serviceStep.additionalCoverage.coverageTooltip' | translate"
        >
          <button
            type="button"
            class="additional-coverage__tooltip-trigger"
            [attr.aria-label]="
              'createShipment.serviceStep.additionalCoverage.coverageTooltipAria' | translate
            "
            aria-describedby="additional-coverage-tooltip-desc"
            (click)="$event.preventDefault(); $event.stopPropagation()"
            (focus)="coverageTooltip.show()"
            (blur)="coverageTooltip.hide()"
          >
            <puro-icon name="info-circle-tooltip" size="sm" aria-hidden="true" />
          </button>
        </puro-tooltip>
      </div>

      <div class="additional-coverage__fields" [formGroup]="form()">
        <puro-input
          class="additional-coverage__field"
          data-testid="declared-value-input"
          [label]="'createShipment.serviceStep.additionalCoverage.declaredValueLabel' | translate"
          type="text"
          inputmode="decimal"
          labelPosition="floating"
          [startAdornment]="true"
          [formControl]="form().controls.declaredValue"
          [error]="hasDeclaredValueError()"
          [errorMessage]="
            hasDeclaredValueError() && declaredValueErrorKey()
              ? (declaredValueErrorKey() | translate)
              : ''
          "
          (focusout)="onFieldBlur(form().controls.declaredValue)"
        >
          <span startAdornment class="additional-coverage__currency" aria-hidden="true">$</span>
        </puro-input>

        <puro-input
          class="additional-coverage__field"
          data-testid="package-description-input"
          [label]="
            'createShipment.serviceStep.additionalCoverage.packageDescriptionLabel' | translate
          "
          type="text"
          labelPosition="floating"
          [required]="isDescriptionRequired()"
          [endAdornment]="true"
          [formControl]="form().controls.packageDescription"
          [error]="hasPackageDescriptionError()"
          [errorMessage]="
            hasPackageDescriptionError() && packageDescriptionErrorKey()
              ? (packageDescriptionErrorKey() | translate)
              : ''
          "
          (focusout)="onFieldBlur(form().controls.packageDescription)"
        >
          <span endAdornment class="additional-coverage__description-tooltip">
            <span class="visually-hidden" id="package-description-tooltip-desc">{{
              'createShipment.serviceStep.additionalCoverage.packageDescriptionTooltip' | translate
            }}</span>
            <puro-tooltip
              #packageDescriptionTooltip
              [content]="
                'createShipment.serviceStep.additionalCoverage.packageDescriptionTooltip'
                  | translate
              "
            >
              <button
                type="button"
                class="additional-coverage__tooltip-trigger"
                data-testid="package-description-tooltip"
                [attr.aria-label]="
                  'createShipment.serviceStep.additionalCoverage.packageDescriptionTooltipAria'
                    | translate
                "
                aria-describedby="package-description-tooltip-desc"
                (click)="$event.preventDefault(); $event.stopPropagation()"
                (focus)="packageDescriptionTooltip.show()"
                (blur)="packageDescriptionTooltip.hide()"
              >
                <puro-icon name="alert-black" size="sm" aria-hidden="true" />
              </button>
            </puro-tooltip>
          </span>
        </puro-input>
      </div>
    </section>
  }
</section>
